import React from 'react'
import './serviceProviderCard.css'
import { Rating } from '@mui/material'
import { Link } from 'react-router-dom'
import Button from '../button/Button'

function ServiceProviderCard({ serviceProvider }) {
    const price = serviceProvider.price
    return (
        <div className='serviceprovider_card'>
            <div className='provider_image'>
                <img src={serviceProvider.imageUrl} />
            </div>

            <div className='provider_details'>
                <h3>{serviceProvider.vendor.name}</h3>
                <h6 style={{ marginTop: "1rem" }}>{serviceProvider.name}</h6>
                {
                    serviceProvider.isAvailable ? (
                        <h6><i class='bx bx-badge-check' style={{ marginTop: '0.5rem'}}></i> available</h6>
                    ) : (
                        <h6><i class='bx bx-shield-x' style={{ marginTop: '0.5rem'}}></i> unavailable</h6>
                    )
                }
                
                <div className='provider_bio'>
                    <p>
                        {serviceProvider.description}
                    </p>
                </div>

                <div className='provider_rating'>
                    <Rating name="read-only" value={serviceProvider.averageRating} precision={0.5} readOnly />
                </div>

                <div className='provider_rate'>
                    <h6>{`Rate per ${serviceProvider.unit}:`}</h6>
                    <p>KShs {serviceProvider.price}</p>
                </div>
                
                <div className='view_btn'>
                    <Button
                        action={`/provider?id=${serviceProvider.id}`}
                        content={`Book`}
                        contentColor='white'
                        borderRadius="all"
                        buttonColor='main-bg'
                    />
                </div>

            </div>
        </div>
    )
}

export default ServiceProviderCard
